import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import Countdown from 'react-countdown';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';


const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

const Completionist = () => "";

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 50, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 50, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 50, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--secondary-text);
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 50, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 50, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 50, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
  margin-top: 1em;
`;

export const StyledImg = styled.img`
  // box-shadow: 0px 4px 0px -2px rgba(250, 50, 250, 0.3);
  border: none;
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--accent-text);
  text-decoration: none;
`;


function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Please select how many NFTs you want to mint in one transcation.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    MAX_MINT_PER_TX: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
    LAUNCH_DATE: "",
    END_DATE: "",
  });


  const claimNFTs = async () => {
    await dispatch(fetchData(blockchain.account));
    if (mintAmount + Number(data.totalSupply) > CONFIG.MAX_SUPPLY) {
      setFeedback("Not enough NFTs left to mint!");
      return false;
    }
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong. Please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Hooray! You successfully minted some ${CONFIG.NFT_NAME} NFTs! After the big reveal, you can see how your NFTs look on ${CONFIG.MARKETPLACE}.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > CONFIG.MAX_MINT_PER_TX) {
      newMintAmount = CONFIG.MAX_MINT_PER_TX;
    }
    setMintAmount(newMintAmount);
  };

  const setMintAmountInput = (e) => {
    let newMintAmount = parseInt(e.target.value);
    if (newMintAmount > CONFIG.MAX_MINT_PER_TX) {
      newMintAmount = CONFIG.MAX_MINT_PER_TX;
    }
    else if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? (isMobile ? "/config/images/bgMobile.jpg" : "/config/images/bg.jpg") : null}
      >
        {/* <StyledLogo alt={"logo"} src={"/config/images/logo.jpg"} /> */}
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"preview"} src={"/config/images/preview.gif"} />
          </s.Container>
          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "var(--accent)",
              padding: 24,
              borderRadius: 24,
              border: "none",
              // boxShadow: "0px 4px 0px -2px rgba(250,50,250,0.3)",
            }}
          >
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--secondary-text)",
                paddingBottom: "1em",
                maxWidth: "450px",
              }}
            >
              <img
                style={{
                  marginTop: "1em",
                  maxWidth: "100%",
                }}
                src="/config/images/logo.png"
                alt="The BCH Gang" />
              <p
                style={{
                  marginTop: "1em",
                }}
              >The BCH gang fights against the evil central bankers for money -- not just for themselves but for everybody. The BCH gang wants a separation of money and state. They believe that money should not be centrally controlled and printed at will. They want to establish a new kind of sound money that can be used to store value and to handle everyday transactions. They want a true peer-to-peer electronic cash for the world.
              </p>
              <p
                style={{
                  marginTop: "1em",
                }}
              >
                The BCH Gang NFT collection is coming to #SmartBCH soon! Stay tuned!
              </p>
              {/* <p
                style={{
                  marginTop: "1em",
                }}
              >
                To read more about our vision and roadmap, check out our <StyledLink target={"_blank"} href="https://read.cash/@worldofmasksbch/background-and-roadmap-d9b03e0c">
                  release announcement
                </StyledLink>.
              </p> */}
            </s.TextDescription>
            {new Date() > new Date(CONFIG.LAUNCH_DATE) ? (
              <>
                <s.TextTitle
                  style={{
                    textAlign: "center",
                    fontSize: 50,
                    fontWeight: "bold",
                    fontFamily: "Liberation Mono",
                    color: "var(--accent-text)",
                  }}
                >
                  {data.totalSupply} / {CONFIG.MAX_SUPPLY}
                </s.TextTitle>
                <s.TextDescription
                  style={{
                    textAlign: "center",
                    fontFamily: "Liberation Mono",
                    color: "var(--secondary-text)",
                  }}
                >
                  <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                    {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
                  </StyledLink>
                </s.TextDescription>
                <s.SpacerSmall />
              </>
            ) : null}
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                  <img style={{
                    width: "192px",
                  }} src="/oasis_logo.svg" alt="Oasis" />
                </StyledLink>
              </>
            ) : (
              <>
                {/* <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  The special offer for the first 2,500 Pixel Guy Club NFTs: 1 NFT for 0.01 BCH  
                </s.TextTitle> */}
                <s.SpacerSmall />
                {/* <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  Minting begin and minting price will be announced soon!
                  </s.TextTitle>  */}
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--primary-text)" }}
                >
                  1 {CONFIG.SYMBOL} can be minted for {CONFIG.DISPLAY_COST}{" "}
                  {CONFIG.NETWORK.SYMBOL} plus gas fees.
                </s.TextTitle>
                {/*<s.SpacerSmall />
                 <s.TextTitle
                  style={{ textAlign: "center", color: "var(--secondary-text)" }}
                >
                  To show our appreciation for the community we won't increase the minting price. Originally the price was planned to increase every 2,500 minted NFTs by 0.005 BCH per NFT.
                </s.TextTitle>*/}
                <s.SpacerSmall />
                {blockchain.account === "" ||
                  blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--secondary-text)",
                      }}
                    >
                      Please connect MetaMask to the {CONFIG.NETWORK.NAME} network and then connect to this website.
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--secondary-text)",
                      }}
                    >
                      If you are on a computer, please unlock your MetaMask browser extension first and then refresh this page before clicking the "connect" button.
                    </s.TextDescription>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--secondary-text)",
                      }}
                    >
                      <s.SpacerSmall />
                      You can mint up to {CONFIG.MAX_MINT_PER_TX} NFTs in one transaction.
                    </s.TextDescription>

                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--primary-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    {new Date() > new Date(CONFIG.LAUNCH_DATE) ? (
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--primary-text)",
                        }}
                      >
                        {feedback}
                      </s.TextDescription>
                    ) : null}

                    <s.SpacerMedium />
                    {/* {new Date() < new Date(CONFIG.END_DATE) ? ( */}
                    {new Date() > new Date(CONFIG.LAUNCH_DATE) ? (

                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledRoundButton
                          style={{ lineHeight: 0.4 }}
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            decrementMintAmount();
                          }}
                        >
                          -
                        </StyledRoundButton>
                        <s.SpacerMedium />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          <input type={"number"} style={{ width: "50px", padding: "5px" }} value={mintAmount} onChange={setMintAmountInput} />
                        </s.TextDescription>
                        <s.SpacerMedium />
                        <StyledRoundButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            incrementMintAmount();
                          }}
                        >
                          +
                        </StyledRoundButton>
                      </s.Container>
                    ) : null}
                    <s.SpacerSmall />
                    {/* {new Date() < new Date(CONFIG.END_DATE) ? ( */}
                    {new Date() > new Date(CONFIG.LAUNCH_DATE) ? (
                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            claimNFTs();
                            getData();
                          }}
                        >
                          {claimingNft ? "BUSY" : "MINT"}
                        </StyledButton>
                      </s.Container>
                    ) : (
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          fontSize: 28,
                          color: "var(--primary-text)",
                        }}
                      >
                        The minting begins {new Date(CONFIG.LAUNCH_DATE).toUTCString()}.
                        {/* The minting ended {new Date(CONFIG.END_DATE).toUTCString()}. */}
                      </s.TextDescription>
                    )}
                  </>
                )}
              </>
            )}
            {/* {new Date() < new Date(CONFIG.END_DATE) ? (
            <s.TextDescription
                      style={{
                        textAlign: "center",
                        fontSize: 28,
                        color: "var(--primary-text)",
                      }}
                    >
                      Minting is possible until {new Date(CONFIG.END_DATE).toUTCString()}.
                    </s.TextDescription>
                    ) : (
                      null
                    )} */}
            <div className="countdown" style={{
              textAlign: "center",
              fontSize: 40,
              fontWeight: "bold",
              fontFamily: "Liberation Mono",
              color: "var(--primary-text)",
            }}>
              {/* <Countdown
                date={new Date(CONFIG.END_DATE)}
              >
                <Completionist />
              </Countdown> */}

              <Countdown
                date={new Date(CONFIG.LAUNCH_DATE)}
              >
                <Completionist />
              </Countdown>
            </div>
            <s.Container jc={"center"} ai={"center"} style={{ width: "90%" }}>
              <s.SpacerMedium />
              <s.SpacerMedium />
              <s.TextDescription
                style={{
                  textAlign: "center",
                  color: "var(--secondary-text)",
                }}
              >
                We have set the gas limit to {CONFIG.GAS_LIMIT} so that the smart contract can
                successfully mint the {CONFIG.NFT_NAME} NFTs. We recommend not to lower the
                gas limit. Otherwise the minting might fail.
                Don't worry about overspending: Unused gas is sent back to your wallet.
              </s.TextDescription>
              <s.SpacerSmall />
              <s.TextDescription
                style={{
                  textAlign: "center",
                  fontSize: 20,
                  color: "var(--accent-text)",
                }}
              >
                Please note: Once you make the purchase, you cannot undo this action.
              </s.TextDescription>

              <s.SpacerSmall />
              {/* <s.TextDescription
                style={{
                  textAlign: "center",
                  fontSize: 20,
                  color: "var(--accent-text)",
                }}
              > */}
              <StyledLink target={"_blank"} href="http://thebchgang.cash">Learn more about the BCH Gang project on  our website</StyledLink>
              {/* </s.TextDescription> */}
            </s.Container>
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg
              alt={"preview"}
              src={"/config/images/preview.gif"}
            />
          </s.Container>

        </ResponsiveWrapper>
        <s.SpacerSmall />
        <s.Container
          jc={"center"}
          ai={"center"}
          style={{
            margin: "0",
            padding: "0",
            color: "#efefef",
          }}
        >
          {/* <a href="https://github.com/zquestz/reapers.cash" target="_blank"><img src="/github-alt-brands.svg" /></a> */}
          <div className="social">
            <a href="https://t.me/TheBCHGang" target="_blank"><img src="/telegram-plane-brands.svg" /></a>
            <a href="http://twitter.com/thebchgang" target="_blank"><img src="/twitter-brands.svg" /></a>
            {/* <a href="https://www.instagram.com/nft_club_official/" target="_blank"><img src="/instagram-brands.svg" /></a> */}
          </div>
        </s.Container>

      </s.Container>

    </s.Screen>
  );
}

export default App;
